import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    navigation: [
      { label: '首页', path: '/' },
      { label: '电影库', path: '/category/all' },
      { label: '电视剧', path: '/category/tvseries' },
      { label: '动漫', path: '/category/animation' },
      { label: '关于我们', path: '/about' },
    ],
    categories: [
      { label: '动作片', path: '/category/action' },
      { label: '喜剧片', path: '/category/comedy' },
      { label: '科幻片', path: '/category/scifi' },
      { label: '悬疑片', path: '/category/suspense' },
      { label: '爱情片', path: '/category/romance' },
    ],
    support: [
      { label: '常见问题', path: '/about' },
      { label: '播放帮助', path: '/about' },
      { label: '意见反馈', path: '/about' },
      { label: '版权声明', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  };

  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl text-foreground-100">奇优影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              奇优影院提供不缓冲、流畅播放的观影体验，秒开无卡顿极速播放。高清电影电视剧全集免费在线观看，畅享顺畅视觉盛宴。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-background-300/60 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-background-300/60 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-500 hover:bg-background-300/60 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-200 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-200 mb-4">影片分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-200 mb-4">帮助与支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-background-200/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; 2026 奇优影院 qiyoucinema.com - 高清电影电视剧免费在线观看
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">关于我们</Link>
              <Link to="/about" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">隐私政策</Link>
              <Link to="/about" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">服务条款</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}